import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import {signupConfirmEmail} from "../actions";
import SectionTitle from "../../Layout/components/SectionTitle";
import {withLocalize} from 'react-localize-redux';
import translations from '../translations/translations_confirm_email_address';
import ReactHtmlParser from 'react-html-parser';

class ConfirmEmailAddressContainer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push('/');
        }

        const key = this.props.match.params.key;
        const idUser = this.props.match.params.user;

        this.props.signupConfirmEmail(key, idUser);
    }

    render() {
        const {signupConfirmEmailLoading, signupConfirmEmailSuccess} = this.props.auth;

        const pageTitle = this.props.translate('auth_confirm_email_address.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        const errorTitle = ReactHtmlParser(this.props.translate('auth_confirm_email_address.error_message_title', null, {renderInnerHtml: false}));
        const successTitle = ReactHtmlParser(this.props.translate('auth_confirm_email_address.success_message_title', null, {renderInnerHtml: false}));

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'signup-confirm-email vertical-content-force-height-100'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                        <div className="col-6 col-sm-10 mx-auto">
                            <div className="text-center">
                                {signupConfirmEmailLoading &&
                                    <LoadingSpinner/>
                                }
                                {!signupConfirmEmailLoading && !signupConfirmEmailSuccess &&
                                    <SectionTitle cssClass="" title={<Fragment>{errorTitle}</Fragment>} subtitle={this.props.translate('auth_confirm_email_address.error_message_subtitle', null, { renderInnerHtml: false })} />
                                }
                                {!signupConfirmEmailLoading && signupConfirmEmailSuccess &&
                                    <SectionTitle cssClass="" title={<Fragment>{successTitle}</Fragment>} subtitle={this.props.translate('auth_confirm_email_address.success_message_subtitle', null, { renderInnerHtml: false })} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

ConfirmEmailAddressContainer.propTypes = {
    signupConfirmEmail: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default withRouter(connect(mapStateToProps, {signupConfirmEmail})(withLocalize(ConfirmEmailAddressContainer)));


// WEBPACK FOOTER //
// ./src/features/Auth/components/ConfirmEmailAddressContainer.js